module.exports = __webpack_public_path__ + "img/landing.b4371abf.webp";